import { fetcher } from "../api/api";
import { api, tokenHelper } from "../api/weserve/api-helper";
import { WeserveSortOptions } from "../utils/query-params";
import { Community } from "./community";
import { OrgBootstrap } from "./organization";

export interface BoardProps {
  community: Community;
  orgBootstrap: OrgBootstrap;
  filterDefaults?: FilterDefaults;
  initialData?: any;
}

export type FilterDefaults = {
  sort: WeserveSortOptions;
  direction: "asc" | "desc";
  pagination: number;
};

export const MASONRY_DEFAULTS_COLS = {
  default: 4,
  1440: 3,
  1050: 2,
  750: 1,
};

export const boardFetcherFn = (url: string) => {
  return fetcher(api, tokenHelper, url);
};
